import React, { useEffect } from 'react'

import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { enabledUsers, userListFilter } from "Pages/Admin/Users/@signals"


export default function enabledColumn(onChangeEnabled) {

	return [
		{
			name: "enabled",
			label: "Status",
			options: {
				filterType: 'checkbox',
				filterList: userListFilter.value,
				display: 'excluded',
				customBodyRowRender: value => value ? "Enabled" : "Disabled"
			}
		}, {
			name: 'enabled',
			label: 'Status',
			options: {
				filter: false,
				customBodyRowRenderLite: (value, { uid, name }) => <EnabledCell
					enabled={value}
					id={uid}
					name={name}
					onChangeEnabled={onChangeEnabled}/>,
			}
		}]
}

function EnabledCell({ enabled, id, name, onChangeEnabled }) {

	useEffect(() => {
		enabledUsers.value = { ...enabledUsers.value, [id]: enabled }
	}, [id])

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<AppAntSwitch
			onChange={e => {
				enabledUsers.value = { ...enabledUsers.value, [id]: e.target.checked }
				onChangeEnabled(id, e.target.checked, name)
			}}
			checked={!!enabledUsers.value[id] || false}
		/>
	</Box>

}